import { render, staticRenderFns } from "./AddTaskDueDateField.vue?vue&type=template&id=5c2aca29"
import script from "./AddTaskDueDateField.vue?vue&type=script&lang=js"
export * from "./AddTaskDueDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports